"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const fa_1 = require("react-icons/fa");
const md_1 = require("react-icons/md");
const react_switch_1 = __importDefault(require("react-switch"));
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const theme_1 = require("../../../../utils/theme");
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const AddOrUpdateDirectionModal_1 = __importDefault(require("../modals/AddOrUpdateDirectionModal"));
const UseCrudDirection_1 = require("../requestForm/UseCrudDirection");
const direction_api_1 = require("../../../../utils/api/direction/direction.api");
const UpdateDirectionButton = ({ item }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-edit", "data-tooltip-content": "Modifier", onClick: handleShow },
            react_1.default.createElement(md_1.MdEdit, { className: "edit-action-icon" })),
        react_1.default.createElement(AddOrUpdateDirectionModal_1.default, { show: show, handleClose: handleClose, item: item })));
};
const DeleteDirectionButton = ({ id }) => {
    const onDelete = (0, UseCrudDirection_1.UseDeleteDirection)(id);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", "data-tooltip-content": "Supprimer", style: { color: "#E53E3E" }, onClick: () => onDelete() },
            react_1.default.createElement(fa_1.FaTrash, null))));
};
const DirectionAdminTable = ({ search, }) => {
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const { data = { data: [], count: 0 }, isLoading } = (0, direction_api_1.useGetDirectionsQuery)({});
    const filteredData = data.data.filter((item) => {
        var _a, _b;
        const matchSearch = ((_a = item.from) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.toLowerCase())) ||
            ((_b = item.to) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(search.toLowerCase()));
        return matchSearch;
    });
    const paginatedData = filteredData.slice((page - 1) * perPage, page * perPage);
    const [editData, { isError, error }] = (0, direction_api_1.useAddOrUpdateDirectionMutation)();
    console.log({ data });
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement(UpdateDirectionButton, { item: row }),
            react_1.default.createElement(DeleteDirectionButton, { id: row.id })));
    };
    const toggleSticky = (item) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const data = {
            is_active: item.is_active === 1 ? 0 : 1,
            added_by: item.added_by,
            from: item.from,
            to: item.to,
            key: item.key,
            _method: "PUT",
        };
        const action = (data === null || data === void 0 ? void 0 : data.is_active) === 1 ? "activer" : "désactiver";
        const result = yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir ${action} cette direction ?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                try {
                    return yield editData({ id: item === null || item === void 0 ? void 0 : item.id, data });
                }
                catch (err) {
                    sweetalert2_1.default.showValidationMessage(((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) ||
                        `Une erreur de statut ${(err === null || err === void 0 ? void 0 : err.status) || "inconnue"} est survenue`);
                    throw err;
                }
            }),
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        });
        console.log({ result });
        if ((result === null || result === void 0 ? void 0 : result.isConfirmed) && ((_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.data)) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: `Direction ${result.value.data.data.is_sticked === 1
                    ? "activée"
                    : "désactivée"} avec succès !`,
                iconColor: theme_1.Color.themeColor,
                showConfirmButton: false,
                timer: 1500,
            });
        }
    });
    const activeFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "d-flex justify-content-start align-items-center" },
            react_1.default.createElement(react_switch_1.default, { checked: cell, onChange: () => toggleSticky(row), handleDiameter: 12, height: 18, width: 34, offHandleColor: "#4B4B4B", onHandleColor: "#0288D1", offColor: "#F9FAFB", onColor: "#F9FAFB", uncheckedIcon: false, checkedIcon: false, boxShadow: "none", activeBoxShadow: "none", className: "custom-switch", id: "custom-switch-id" })));
    };
    const columns = [
        {
            dataField: "from",
            text: "De",
            headerStyle: () => {
                return {
                    width: "250px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "to",
            text: "À",
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "is_active",
            text: "Active",
            formatter: activeFormatter,
            headerStyle: () => {
                return {
                    width: "100px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "col-lg-12" },
                react_1.default.createElement("div", { className: "admin-table" },
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: paginatedData || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: filteredData === null || filteredData === void 0 ? void 0 : filteredData.length, page: page, onChange: (page, perPage) => {
                                setPerPage(perPage);
                                setPage(page);
                            }, perPage: perPage }))))))));
};
exports.default = DirectionAdminTable;
